<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar nova imagem"
             col-md="col-md-4" offset="3">
    <template v-slot:modalContent>
      <form ref="imgForm" @submit.prevent="submitImgForm">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <FileUpload
                  id="imagem"
                  :multiple="true"
                  accept="image/jpeg,image/jpg,image/png"
                  :maxFileSize="1000000"
                  :showUploadButton="false"
                  chooseLabel="Selecionar Imagem"
                  customUpload
                  @select="onSelect"
              >
                <template #empty>
                  <span>Arraste e solte as imagens aqui ou clique para selecionar.</span>
                </template>
              </FileUpload>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="descricao" v-model="imagem.descricao_img" size="small" style="width: 100%"/>
                <label for="descricao"><strong>Descricão da Imagem: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fecharSubModal')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';


export default {
  name: 'BaseImgCadastro',
  components: {
    BaseModal,
  },
  props: {
    origemId: String,
    origemApp: String,
  },
  data() {
    return {
      imagem: {
        img: [],
        descricao_img: ""
      },
    }
  },
  emits: ['fecharSubModal', 'atualizarListaImg'],
  methods: {
    onSelect(event) {
      this.imagem.img = event.files;
    },
    async submitImgForm() {
      try {
        const form = new FormData();

        form.append('origem_id', this.origemId);
        form.append('origem_app', this.origemApp);
        form.append('descricao', this.imagem.descricao_img);
        this.imagem.img.forEach((file) => {
          form.append('imagem', file);
        });

        const response = await fetch(`${process.env.VUE_APP_API_URL}imagens/create/`, {
          method: "POST",
          credentials: 'include',
          body: form
        });

        if (response.status === 201) {
          const novaImg = await response.json();
          this.$emit("atualizarListaImg", novaImg);
          this.$toastMessage("success", "Registro salvo com sucesso!");
          this.$emit('fecharSubModal')
        } else {
          const errorData = await response.json();
          this.$toastMessage("warn", "Atenção", errorData.detail);
          console.log(errorData)
        }
      } catch (error) {
        this.$toastMessage("warn", error);
        console.log(error);
      }
    },

  },
}
</script>
